import * as React from "react"
const SvgComponent = ({height, width, col}) => (
  <svg

    width={width}
    height={height}
    viewBox="0 0 146 172"

    
  
  >
    <path fill={col} 
    // stroke="black"
    // strokeWidth="2"
    
    d="M40 5.8c-8.9 4.4-10.8 16.1-3.8 23.8 1.7 2 1.8 2.7.8 8.6-1.8 10.2.2 17.8 7.8 30 .9 1.5 1.4 3 1 3.3-.3.4-3.5 1.3-6.9 2.1C28.6 76 14.6 83.3 8 89.8c-3.2 3.1-6.2 6.9-6.5 8.5-1.1 4.4.4 9.6 3.8 13.4 5 5.4 11.1 5.6 23 .8 1.6-.7 1.8-.3 1.5 3.5l-.3 4.2-6.2.1c-5.3.2-6.6.6-9.2 3.1-11.6 11.1-5.6 36.5 10.1 43 8.4 3.5 15.5.7 19.9-7.9l2.5-5.1 5 2.3c10.9 4.9 27.1 5.1 39.7.3 2.8-1.1 5.5-2 5.9-2 .3 0 .9 1.4 1.3 3.1.9 4.2 6.7 9.7 11 10.5 9 1.7 17-3.4 22.5-14 3-5.9 3.4-7.7 3.4-13.9 0-12.7-6.4-20.2-16.4-19.5l-5 .3v-8.3l5 1.9c9.8 3.7 18 1.7 21.3-5.4 2.4-5.1 2.2-10.6-.8-14.9-4.8-7.1-20.7-16.4-33.5-19.7-9.4-2.4-9.9-2.9-6.1-8.1 6.3-8.7 8.6-20 6.1-30.5-.8-3.5-.6-4.3 1.5-6.5 4.8-5.1 5.6-10.2 2.4-16.7C107.5 7.4 102.2 4 97 4c-3.5 0-10.5 3.2-11.7 5.4-.7 1.2-1.5 1.2-6.3 0-5.4-1.4-12.8-1.2-17.7.7-1.6.6-2.6.2-4-1.3-4.1-4.7-11.4-6-17.3-3z" />

  
  </svg>
)
export default SvgComponent
